import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useState } from "react";
import { Field, Form, Formik, FormikHelpers } from "formik";
import axios from "axios";
import { FormButton } from "../Register/RegisterStyles";
import { Loader } from "../../../components/Loader/Loader";
import { ArticleBlock, FormMainBlock } from "../FormsGeneralStyles";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../store/hooks";
import { InfoField } from "./TwoFactorPageStyles";
import { generateRedirectUrl } from "../../../functions/routingFuntion";

export const TwoFactorPage = () => {
  const [isSuccess, setSuccess] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = useAppSelector((state) => state.locale.localStorageValue);

  const handleSubmit = async (
    values: { code: string },
    formikHelpers: FormikHelpers<{ code: string }>
  ) => {
    setInProgress(true);
    setSuccess(false);

    try {
      const email = localStorage.getItem("email");
      const password = localStorage.getItem("password");

      const response = await axios.post(
        "https://api.demo-q17.com/auth/login",
        { email, password, secret: values.code, remember: true },
        {
          headers: {
            "Accept": "application/json",
            "Accept-Language": lang,
          },
        }
      );

      // localStorage.setItem("token", response.data.token);
      setSuccess(true);

      localStorage.removeItem("email");
      localStorage.removeItem("password");

      const redirectUrl = generateRedirectUrl(
        "https://terminal.demo-q17.com",
        lang
      );
      window.location.href = redirectUrl;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        formikHelpers.setFieldError("code", t("formsWarnings.invalidCode"));
      } else {
        console.error("Unexpected error:", error);
      }
    } finally {
      setInProgress(false);
    }
  };

  // const resendCode = async () => {
  //   try {
  //     const userId = localStorage.getItem("userId");
  //     await axios.post(
  //       "http://localhost/auth/resend-2fa",
  //       { userId },
  //       {
  //         headers: {
  //           Accept: "application/json",
  //           "Accept-Language": lang,
  //         },
  //       }
  //     );
  //     alert(t("formsWarnings.codeResent"));
  //   } catch (error) {
  //     console.error("Error resending code:", error);
  //   }
  // };

  const CodeSchema = Yup.object().shape({
    code: Yup.string()
      .min(2, t("formsWarnings.tooShort"))
      .required(t("formsWarnings.codeRequired")),
  });

  return (
    <main>
      <FormMainBlock>
        <section>
          <div className="container__standart div__container">
            <div className="div__form">
              <h3>{t("twoFactorPage.title1")}</h3>
              <InfoField>{t("twoFactorPage.blockInfo11")}</InfoField>
              <Formik
                initialValues={{
                  code: "",
                }}
                validationSchema={CodeSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched }) => (
                  <Form className="form__content">
                    <ArticleBlock>
                      <div className="div__main__block">
                        <Field
                          id="code"
                          name="code"
                          placeholder={t("form.code")}
                          type="text"
                          className={`input__styles ${
                            touched.code && errors.code && "!border-[#eb5757]"
                          }`}
                        />
                        {touched.code && errors.code && (
                          <span className="form__req__info">{errors.code}</span>
                        )}
                      </div>
                    </ArticleBlock>
                    <div>
                      {inProgress ? (
                        <Loader height="41" width="100%" />
                      ) : (
                        <FormButton
                          type="submit"
                          className="white__button flex__center log__btn"
                          style={{ marginTop: "50px" }}
                        >
                          {isSuccess ? t("form.successfully") : t("form.send")}
                        </FormButton>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
              {/* <button
                type="button"
                onClick={resendCode}
                className="white__button flex__center resend__btn"
              >
                {t("form.resendCode")}
              </button> */}
            </div>
          </div>
        </section>
      </FormMainBlock>
    </main>
  );
};
